export function StarBadge({
  count,
  ariaLabel,
}: {
  count: number;
  ariaLabel?: string;
}) {
  const defaultLabel = `${count} étoile${count > 1 ? "s" : ""} Michelin`;
  return (
    <span className="flex gap-0.5" aria-label={ariaLabel ?? defaultLabel}>
      {Array.from({ length: count }).map((_, i) => (
        <svg
          key={i}
          viewBox="0 0 24 24"
          className="w-4 h-4 fill-amber-400"
          aria-hidden={true}
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </span>
  );
}
